import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="mt-20 bg-gray-950 pb-24 text-gray-300 md:pb-0">
    <div className="kente h-2" />
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-4">
      <div className="space-y-3">
        <Logo light />
        <p className="text-sm text-gray-400">La marketplace multi-vendeurs pensée pour l'Afrique. Premier marché : Sénégal.</p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-display text-base font-bold text-white">Acheter</p>
        <Link to="/recherche" className="block hover:text-orange-400">Tous les produits</Link>
        <Link to="/boutiques" className="block hover:text-orange-400">Boutiques</Link>
        <Link to="/mes-commandes" className="block hover:text-orange-400">Mes commandes</Link>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-display text-base font-bold text-white">Vendre</p>
        <Link to="/devenir-vendeur" className="block hover:text-orange-400">Devenir vendeur</Link>
        <Link to="/abonnements" data-testid="footer-pricing" className="block hover:text-orange-400">Abonnements vendeurs</Link>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-display text-base font-bold text-white">Pays</p>
        <p>Sénégal · FCFA : vente et livraison ouvertes</p>
        <p className="text-gray-500">53 autres pays africains : bientôt</p>
      </div>
    </div>
    <p className="border-t border-white/10 py-5 text-center text-xs text-gray-500">© 2026 Casadeal. Les produits et boutiques marqués « Démo » sont des données de démonstration.</p>
  </footer>
);
